import styled from 'styled-components'
import React from 'react'
import PropTypes from 'prop-types'
import { Box, Text, Flex, getPaletteColor } from 'pcln-design-system'
import { VipIcon } from '@pcln/vip'

const RightAlignedFlex = styled(Flex)`
  ${(props) => props.theme.flyQueries.tablet} {
    margin-left: auto !important;
  }
`

const Banner = styled(Box)`
  letter-spacing: 0.8px;
  position: relative;
  padding: 4px 8px;
  line-height: 15px;
`

const PkgVipBannerMessage = styled(Text.span)`
  font-size: 12px;
  color: ${getPaletteColor('primary.dark')};
  font-weight: ${(props) => props.theme.bold};
`

const PkgVipBannerSavings = styled(Text.span)`
  font-size: 12px;
  color: ${getPaletteColor('primary.dark')};
  font-weight: ${(props) => props.theme.bold};
  display: inline-block;
`

const messageIfNull = {
  bannerMessage: 'FLIGHT SALE',
}

const SaleBanner = ({
  bannerMessage,
  savingsMessage,
  style,
  bg,
  borderRadius,
  shouldShowMerchBadgeAndPkgDiscount,
  isPackageVIPDiscount,
}) => {
  const Wrapper = shouldShowMerchBadgeAndPkgDiscount ? RightAlignedFlex : Flex
  return (
    <Wrapper align='center' alignItems='center' data-test='sale-banner' style={style}>
      {isPackageVIPDiscount ? (
        <Flex data-testid='sale-banner-pkg-vip'>
          <VipIcon fontSize='24px' variation='vip' />
          <Banner bg='none' borderRadius={borderRadius}>
            <PkgVipBannerMessage data-test='sale-banner-message'>
              {bannerMessage}&nbsp; . &nbsp;
            </PkgVipBannerMessage>
            <PkgVipBannerSavings data-test='sale-banner-savings'>{savingsMessage}</PkgVipBannerSavings>
          </Banner>
        </Flex>
      ) : (
        <Banner color={bg} borderRadius={borderRadius}>
          <Text.span fontSize={0} fontWeight='bold' data-test='sale-banner-message'>
            {bannerMessage && bannerMessage.trim().length > 0 ? bannerMessage : messageIfNull.bannerMessage}
          </Text.span>
          :&nbsp;
          {savingsMessage && savingsMessage.trim().length > 0 ? (
            <Text.span fontSize={0} fontWeight='bold' data-test='sale-banner-savings'>
              {savingsMessage}
            </Text.span>
          ) : null}
        </Banner>
      )}
    </Wrapper>
  )
}

Banner.defaultProps = {
  bannerMessage: 'FLIGHT SALE',
  savingsMessage: '',
  color: 'warning.base',
  borderRadius: 'full',
}

SaleBanner.propTypes = {
  borderRadius: PropTypes.string,
  bannerMessage: PropTypes.string,
  savingsMessage: PropTypes.string,
  style: PropTypes.object,
  bg: PropTypes.string,
  shouldShowMerchBadgeAndPkgDiscount: PropTypes.bool,
  isPackageVIPDiscount: PropTypes.bool,
}

export default SaleBanner
